// SEX CHANGER
const RFTP_SEX_OPTIONS = new Set(['all', 'men', 'women']);
const RFTP_SEX_TRANSITION_DURATION = 950;
const rftpReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
let rftpChosenSex = 'all';
try {
  const savedSex = window.localStorage.getItem('rftp-sex');
  if (RFTP_SEX_OPTIONS.has(savedSex)) rftpChosenSex = savedSex;
} catch (error) {
  // The selector also works when browser storage is unavailable.
}
document.body.setAttribute('data-chosen-sex', rftpChosenSex);
let rftpPendingSex = null;
let rftpSexChangeRequest = 0;
let rftpActiveSexTransition = null;
let rftpSexWebGLRenderer = null;
const rftpSexTextureCache = new Map();

// Set sizing and loading policy before URLs. Inactive images have no network
// source until selected or explicitly warmed by interaction with the selector.
function loadSexImage(image) {
  for (const attribute of ['srcset', 'src']) {
    const value = image.getAttribute(`data-rftp-${attribute}`);
    if (value) {
      image.setAttribute(attribute, value);
      image.removeAttribute(`data-rftp-${attribute}`);
    }
  }
}

function loadSelectedSexImages(chosenSex) {
  document.querySelectorAll(`img[data-sex="${chosenSex}"]`).forEach(loadSexImage);
}

// No per-image layout reads: upgrading hundreds of placeholders must not
// alternate layout measurement and DOM writes.
;(() => {
  class RftpSexImage extends HTMLElement {
    connectedCallback() {
      const imgSex = this.getAttribute('data-sex');
      const img = document.createElement('img');
      for (const attr of [...this.attributes]) {
        const name = ['src', 'srcset'].includes(attr.name) ? `data-rftp-${attr.name}` : attr.name;
        img.setAttribute(name, attr.value);
      }
      img.loading = 'lazy';
      img.decoding = 'async';
      img.fetchPriority = 'auto';
      img.setAttribute('aria-hidden', String(imgSex !== rftpChosenSex));
      if (imgSex === rftpChosenSex) loadSexImage(img);
      this.replaceWith(img);
    }
  }
 
  customElements.define('rftp-sex-image', RftpSexImage);
})();

const RFTP_SEX_VERTEX_SHADER = `
  attribute vec2 aPosition;
  varying vec2 vUv;

  void main() {
    vUv = aPosition * 0.5 + 0.5;
    gl_Position = vec4(aPosition, 0.0, 1.0);
  }
`;

const RFTP_SEX_FRAGMENT_SHADER = `
  precision mediump float;

  uniform sampler2D uFromTexture;
  uniform sampler2D uToTexture;
  uniform vec2 uFromSize;
  uniform vec2 uToSize;
  uniform vec2 uResolution;
  uniform float uFromFit;
  uniform float uToFit;
  uniform float uProgress;
  uniform float uGrayscale;
  varying vec2 vUv;

  float hash(vec2 point) {
    vec3 point3 = fract(vec3(point.xyx) * 0.1031);
    point3 += dot(point3, point3.yzx + 33.33);
    return fract((point3.x + point3.y) * point3.z);
  }

  float noise(vec2 point) {
    vec2 cell = floor(point);
    vec2 local = fract(point);
    local = local * local * (3.0 - 2.0 * local);

    return mix(
      mix(hash(cell), hash(cell + vec2(1.0, 0.0)), local.x),
      mix(hash(cell + vec2(0.0, 1.0)), hash(cell + vec2(1.0, 1.0)), local.x),
      local.y
    );
  }

  vec2 imageUv(vec2 screenUv, vec2 imageSize, float fit) {
    if (fit > 1.5) {
      return screenUv;
    }

    vec2 uv = screenUv - 0.5;
    float imageAspect = imageSize.x / imageSize.y;
    float elementAspect = uResolution.x / uResolution.y;

    if (fit > 0.5) {
      if (imageAspect > elementAspect) {
        uv.x *= elementAspect / imageAspect;
      } else {
        uv.y *= imageAspect / elementAspect;
      }
    } else if (imageAspect > elementAspect) {
      uv.y *= imageAspect / elementAspect;
    } else {
      uv.x *= elementAspect / imageAspect;
    }

    return uv + 0.5;
  }

  float uvIsVisible(vec2 uv) {
    return step(0.0, uv.x) * step(uv.x, 1.0) * step(0.0, uv.y) * step(uv.y, 1.0);
  }

  vec4 fromColor(vec2 screenUv) {
    vec2 uv = imageUv(screenUv, uFromSize, uFromFit);
    vec4 color = texture2D(uFromTexture, clamp(uv, 0.0, 1.0));
    color.a *= uvIsVisible(uv);
    return color;
  }

  vec4 toColor(vec2 screenUv) {
    vec2 uv = imageUv(screenUv, uToSize, uToFit);
    vec4 color = texture2D(uToTexture, clamp(uv, 0.0, 1.0));
    color.a *= uvIsVisible(uv);
    return color;
  }

  void main() {
    float progress = 1.0 - pow(1.0 - uProgress, 1.4);
    float energy = smoothstep(0.0, 0.06, uProgress) * (1.0 - smoothstep(0.84, 1.0, uProgress));
    float gridX = mix(min(uResolution.x, 150.0), clamp(uResolution.x / 14.0, 10.0, 24.0), energy);
    vec2 grid = vec2(gridX, max(2.0, floor(gridX * uResolution.y / uResolution.x)));
    vec2 cell = floor(vUv * grid);
    vec2 cellUv = (cell + 0.5) / grid;

    float organicWave = (noise(vec2(cellUv.y * 3.2, 1.7)) - 0.5) * 0.38;
    organicWave += sin(cellUv.y * 9.0 + progress * 2.5) * 0.05;
    float front = mix(-0.05, 1.4, progress);
    float field = cellUv.x + organicWave + (hash(cell + 8.1) - 0.5) * 0.075;
    float distanceToFront = abs(field - front);
    float band = (1.0 - smoothstep(0.02, 0.38, distanceToFront)) * energy;
    vec2 pixelUv = mix(vUv, cellUv, band);

    float displacement = (hash(cell + 31.7) - 0.5) * band;
    vec2 fromUv = pixelUv + vec2(0.065 * band, displacement * 0.045);
    vec2 toUv = pixelUv - vec2(0.065 * band, displacement * 0.045);
    float reveal = 1.0 - smoothstep(-0.025, 0.025, field - front);
    reveal *= step(0.0001, uProgress);

    vec4 color = mix(fromColor(fromUv), toColor(toUv), reveal);
    float edge = (1.0 - smoothstep(0.0, 0.06, distanceToFront)) * energy;
    color.rgb += edge * 0.1;

    float luminance = dot(color.rgb, vec3(0.299, 0.587, 0.114));
    color.rgb = mix(color.rgb, vec3(luminance), uGrayscale);
    gl_FragColor = color;
  }
`;

function getDirectSexImage(container, sex) {
  return Array.from(container.children).find(child => child.matches?.(`img[data-sex="${sex}"]`));
}

function isSexImageContainerVisible(container) {
  const bounds = container.getBoundingClientRect();

  return bounds.width > 0
    && bounds.height > 0
    && bounds.bottom > 0
    && bounds.right > 0
    && bounds.top < window.innerHeight
    && bounds.left < window.innerWidth;
}

function getSexImageGroups(previousSex, chosenSex) {
  const containers = new Set();
  const groups = [];

  document.querySelectorAll(`img[data-sex="${previousSex}"]`).forEach(fromImage => {
    const container = fromImage.parentElement;

    if (!container || containers.has(container) || !isSexImageContainerVisible(container)) {
      return;
    }

    const toImage = getDirectSexImage(container, chosenSex);

    if (
      !toImage
      || !fromImage.complete
      || !toImage.complete
      || fromImage.naturalWidth === 0
      || toImage.naturalWidth === 0
      // || (fromImage.currentSrc || fromImage.src) === (toImage.currentSrc || toImage.src)
    ) {
      return;
    }

    containers.add(container);
    groups.push({ container, fromImage, toImage });
  });

  // Measure the destination layout as well, since filtering can move a card
  // from outside the viewport into view without hiding the card itself.
  const bodySex = document.body.getAttribute('data-chosen-sex');

  try {
    document.body.setAttribute('data-chosen-sex', chosenSex);

    document.querySelectorAll(`img[data-sex="${chosenSex}"]`).forEach(toImage => {
      const container = toImage.parentElement;

      if (
        !container
        || containers.has(container)
        || !container.closest('product-card')
        || !isSexImageContainerVisible(container)
        || !toImage.complete
        || toImage.naturalWidth === 0
      ) {
        return;
      }

      const previousImage = getDirectSexImage(container, previousSex);
      const fromImage = previousImage?.complete && previousImage.naturalWidth > 0
        ? previousImage
        : toImage;

      containers.add(container);
      groups.push({ container, fromImage, toImage });
    });
  } finally {
    if (bodySex === null) {
      document.body.removeAttribute('data-chosen-sex');
    } else {
      document.body.setAttribute('data-chosen-sex', bodySex);
    }
  }

  return groups;
}

function compileSexShader(gl, type, source) {
  const shader = gl.createShader(type);
  gl.shaderSource(shader, source);
  gl.compileShader(shader);

  if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
    const message = gl.getShaderInfoLog(shader);
    gl.deleteShader(shader);
    throw new Error(`Sex transition shader failed to compile: ${message}`);
  }

  return shader;
}

function createSexShaderProgram(gl) {
  const vertexShader = compileSexShader(gl, gl.VERTEX_SHADER, RFTP_SEX_VERTEX_SHADER);
  const fragmentShader = compileSexShader(gl, gl.FRAGMENT_SHADER, RFTP_SEX_FRAGMENT_SHADER);
  const program = gl.createProgram();
  gl.attachShader(program, vertexShader);
  gl.attachShader(program, fragmentShader);
  gl.linkProgram(program);
  gl.deleteShader(vertexShader);
  gl.deleteShader(fragmentShader);

  if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
    const message = gl.getProgramInfoLog(program);
    gl.deleteProgram(program);
    throw new Error(`Sex transition shader failed to link: ${message}`);
  }

  return program;
}

function createSexTexture(gl, image) {
  const texture = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, texture);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, image);
  return texture;
}

function getSexTexture(gl, image) {
  const source = image.currentSrc || image.src;
  let texture = rftpSexTextureCache.get(source);

  if (!texture) {
    texture = createSexTexture(gl, image);
    rftpSexTextureCache.set(source, texture);
  }

  return texture;
}

function getSexImageFit(image) {
  const objectFit = window.getComputedStyle(image).objectFit;

  if (objectFit === 'cover') {
    return 1;
  }

  if (objectFit === 'fill') {
    return 2;
  }

  return 0;
}

function createSexWebGLRenderer() {
  const canvas = document.createElement('canvas');
  const gl = canvas.getContext('webgl', {
    alpha: true,
    antialias: false,
    depth: false,
    premultipliedAlpha: false,
    powerPreference: 'high-performance'
  });

  if (!gl) {
    return null;
  }

  let program;

  try {
    program = createSexShaderProgram(gl);
    const buffer = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
    gl.bufferData(
      gl.ARRAY_BUFFER,
      new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
      gl.STATIC_DRAW
    );

    const positionLocation = gl.getAttribLocation(program, 'aPosition');
    gl.enableVertexAttribArray(positionLocation);
    gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
    gl.useProgram(program);
  } catch (error) {
    gl.getExtension('WEBGL_lose_context')?.loseContext();
    return null;
  }

  const uniforms = {
    fromTexture: gl.getUniformLocation(program, 'uFromTexture'),
    toTexture: gl.getUniformLocation(program, 'uToTexture'),
    fromSize: gl.getUniformLocation(program, 'uFromSize'),
    toSize: gl.getUniformLocation(program, 'uToSize'),
    resolution: gl.getUniformLocation(program, 'uResolution'),
    fromFit: gl.getUniformLocation(program, 'uFromFit'),
    toFit: gl.getUniformLocation(program, 'uToFit'),
    progress: gl.getUniformLocation(program, 'uProgress'),
    grayscale: gl.getUniformLocation(program, 'uGrayscale')
  };

  function ensureSize(width, height) {
    if (canvas.width < width || canvas.height < height) {
      canvas.width = Math.max(canvas.width, width);
      canvas.height = Math.max(canvas.height, height);
    }
  }

  function renderItem(item, progress, width, height) {
    const y = canvas.height - height;
    gl.useProgram(program);
    gl.enable(gl.SCISSOR_TEST);
    gl.viewport(0, y, width, height);
    gl.scissor(0, y, width, height);
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
    gl.uniform1f(uniforms.progress, progress);
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, item.fromTexture);
    gl.uniform1i(uniforms.fromTexture, 0);
    gl.activeTexture(gl.TEXTURE1);
    gl.bindTexture(gl.TEXTURE_2D, item.toTexture);
    gl.uniform1i(uniforms.toTexture, 1);
    gl.uniform2f(uniforms.fromSize, item.fromImage.naturalWidth, item.fromImage.naturalHeight);
    gl.uniform2f(uniforms.toSize, item.toImage.naturalWidth, item.toImage.naturalHeight);
    gl.uniform2f(uniforms.resolution, width, height);
    gl.uniform1f(uniforms.fromFit, item.fromFit);
    gl.uniform1f(uniforms.toFit, item.toFit);
    gl.uniform1f(uniforms.grayscale, item.grayscale);
    gl.drawArrays(gl.TRIANGLES, 0, 6);
  }

  return { canvas, ensureSize, gl, renderItem };
}

function warmVisibleSexTextures() {
  if (rftpReducedMotionQuery.matches) return;
  rftpSexWebGLRenderer ||= createSexWebGLRenderer();
  if (!rftpSexWebGLRenderer) return;

  const containers = new Set([...document.querySelectorAll('img[data-sex]')].map(image => image.parentElement));
  const visibleContainers = [...containers].filter(container => container && isSexImageContainerVisible(container));
  visibleContainers.forEach(container => {
    container.querySelectorAll('img[data-sex]').forEach(image => {
      loadSexImage(image);
      if (!image.complete || image.naturalWidth === 0) return;
      try {
        getSexTexture(rftpSexWebGLRenderer.gl, image);
      } catch (error) {
        // The transition remains an optional enhancement if an image cannot become a WebGL texture.
      }
    });
  });
}

document.addEventListener('pointerover', event => {
  if (event.target.closest('.rftp-sexchanger')) {
    warmVisibleSexTextures();
  }
});

document.addEventListener('focusin', event => {
  if (event.target.closest('.rftp-sexchanger')) {
    warmVisibleSexTextures();
  }
});

function createSexWebGLTransition(groups) {
  rftpSexWebGLRenderer ||= createSexWebGLRenderer();
  if (!rftpSexWebGLRenderer) {
    return null;
  }

  const { gl } = rftpSexWebGLRenderer;
  const items = [];
  let animationFrame = null;

  try {
    groups.forEach(group => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (!context) {
        throw new Error('Could not create the sex transition presentation canvas');
      }

      canvas.className = 'rftp-sex-webgl-layer';
      canvas.setAttribute('aria-hidden', 'true');
      const item = {
        ...group,
        canvas,
        context,
        fromTexture: getSexTexture(gl, group.fromImage),
        toTexture: getSexTexture(gl, group.toImage),
        fromFit: getSexImageFit(group.fromImage),
        toFit: getSexImageFit(group.toImage),
        grayscale: window.getComputedStyle(group.container).filter.includes('grayscale') ? 1 : 0
      };

      group.container.classList.add('rftp-sex-transitioning');
      group.container.appendChild(canvas);
      items.push(item);
    });
  } catch (error) {
    items.forEach(item => {
      item.canvas.remove();
      item.container.classList.remove('rftp-sex-transitioning');
    });
    return null;
  }

  function render(progress) {
    const pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);
    const dimensions = items.map(item => {
      const bounds = item.container.getBoundingClientRect();
      return {
        height: Math.max(1, Math.round(bounds.height * pixelRatio)),
        width: Math.max(1, Math.round(bounds.width * pixelRatio))
      };
    });

    const maxWidth = Math.max(...dimensions.map(size => size.width));
    const maxHeight = Math.max(...dimensions.map(size => size.height));
    rftpSexWebGLRenderer.ensureSize(maxWidth, maxHeight);

    items.forEach((item, index) => {
      const { height, width } = dimensions[index];

      if (item.canvas.width !== width || item.canvas.height !== height) {
        item.canvas.width = width;
        item.canvas.height = height;
      }

      rftpSexWebGLRenderer.renderItem(item, progress, width, height);
      item.context.clearRect(0, 0, width, height);
      item.context.drawImage(rftpSexWebGLRenderer.canvas, 0, 0, width, height, 0, 0, width, height);
    });
  }

  function dispose() {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    items.forEach(item => {
      item.canvas.remove();
      item.container.classList.remove('rftp-sex-transitioning');
    });
  }

  function play() {
    const startTime = window.performance.now();

    function frame(time) {
      const progress = Math.min((time - startTime) / RFTP_SEX_TRANSITION_DURATION, 1);
      render(progress);

      if (progress < 1) {
        animationFrame = window.requestAnimationFrame(frame);
      } else {
        dispose();
        rftpActiveSexTransition = null;
      }
    }

    animationFrame = window.requestAnimationFrame(frame);
  }

  return { dispose, play, render };
}

function prepareSexWebGLTransition(previousSex, chosenSex) {
  if (rftpReducedMotionQuery.matches) {
    return null;
  }

  const groups = getSexImageGroups(previousSex, chosenSex);

  if (groups.length === 0) {
    return null;
  }

  return createSexWebGLTransition(groups);
}

function cleanUpSexTransition() {
  if (rftpActiveSexTransition) {
    rftpActiveSexTransition.dispose();
    rftpActiveSexTransition = null;
  }
}

function syncSexImageAccessibility(chosenSex) {
  document.querySelectorAll('img[data-sex]').forEach(image => {
    if (image.getAttribute('data-sex') === chosenSex) {
      image.removeAttribute('aria-hidden');
    } else {
      image.setAttribute('aria-hidden', 'true');
    }
  });
}

function keepSexChangerInViewport(sexChanger, viewportTop) {
  if (!sexChanger?.isConnected) {
    return;
  }

  const offset = sexChanger.getBoundingClientRect().top - viewportTop;

  if (Math.abs(offset) > 0.5) {
    window.scrollBy({ top: offset, behavior: 'instant' });
  }
}

function preserveSexChangerViewportPosition(sexChanger, viewportTop) {
  keepSexChangerInViewport(sexChanger, viewportTop);

  // Re-check after paint so native scroll anchoring and late grid reflow cannot
  // move the control away from the position where it was clicked.
  window.requestAnimationFrame(() => {
    keepSexChangerInViewport(sexChanger, viewportTop);
    window.requestAnimationFrame(() => keepSexChangerInViewport(sexChanger, viewportTop));
  });
}

function applySexPreference(chosenSex, transition = null, sexChangerAnchor = null) {
  cleanUpSexTransition();
  rftpChosenSex = chosenSex;
  loadSelectedSexImages(chosenSex);
  syncSexImageAccessibility(chosenSex);
  try {
    window.localStorage.setItem('rftp-sex', chosenSex);
  } catch (error) {
    // Applying a preference must not depend on persistent storage.
  }

  if (transition) {
    rftpActiveSexTransition = transition;
    transition.render(0);
  }

  document.body.setAttribute('data-chosen-sex', chosenSex);

  if (sexChangerAnchor) {
    preserveSexChangerViewportPosition(sexChangerAnchor.element, sexChangerAnchor.viewportTop);
  }

  transition?.play();
}

syncSexImageAccessibility(rftpChosenSex);

new MutationObserver(() => {
  const chosenSex = document.body.getAttribute('data-chosen-sex');

  if (!RFTP_SEX_OPTIONS.has(chosenSex) || chosenSex === rftpChosenSex) {
    return;
  }

  rftpSexChangeRequest += 1;
  rftpPendingSex = null;
  cleanUpSexTransition();
  rftpChosenSex = chosenSex;
  loadSelectedSexImages(chosenSex);
  syncSexImageAccessibility(chosenSex);
}).observe(document.body, { attributes: true, attributeFilter: ['data-chosen-sex'] });

document.addEventListener('click', async event => {
  const button = event.target.closest('.rftp-sexchanger button[data-set-sex]');

  if (!button) {
    return;
  }

  const chosenSex = button.getAttribute('data-set-sex');

  if (!RFTP_SEX_OPTIONS.has(chosenSex) || chosenSex === rftpPendingSex) {
    return;
  }

  if (chosenSex === rftpChosenSex) {
    rftpSexChangeRequest += 1;
    rftpPendingSex = null;
    return;
  }

  const previousSex = rftpChosenSex;
  const sexChanger = button.closest('.rftp-sexchanger');
  const sexChangerAnchor = {
    element: sexChanger,
    viewportTop: sexChanger.getBoundingClientRect().top
  };
  const request = ++rftpSexChangeRequest;
  rftpPendingSex = chosenSex;
  if (!rftpReducedMotionQuery.matches) {
    // Only wait for images participating in the visible transition. Offscreen
    // cards keep native lazy loading, even after changing the preference.
    const images = [...document.querySelectorAll(`img[data-sex="${chosenSex}"]`)]
      .filter(image => image.parentElement && isSexImageContainerVisible(image.parentElement));
    const pending = images.map(image => {
      image.loading = 'eager';
      loadSexImage(image);
      return image.decode().catch(() => {});
    });
    let timeout;
    await Promise.race([
      Promise.all(pending),
      new Promise(resolve => { timeout = window.setTimeout(resolve, 550); })
    ]);
    window.clearTimeout(timeout);
  }
  if (request !== rftpSexChangeRequest) return;
  const transition = prepareSexWebGLTransition(previousSex, chosenSex);

  if (request !== rftpSexChangeRequest) {
    transition?.dispose();
    return;
  }

  rftpPendingSex = null;
  applySexPreference(chosenSex, transition, sexChangerAnchor);
});

// STICKY ADD TO CART
const STICKY_ATC_LOADING_STATE_ATTR = 'data-loading-state-bound';
const STICKY_ATC_MOBILE_VISIBLE_CLASS = 'rftp-mobile-sticky-atc-visible';
const STICKY_ATC_MOBILE_QUERY = window.matchMedia('(max-width: 699px)');
const STICKY_ATC_MOBILE_REVEAL_RATIO = 0.15;
let stickyAddToCartMobileTicking = false;

function getStickyAddToCartButton(stickyAddToCart) {
  return stickyAddToCart?.querySelector('.rftp-sticky-atc__button');
}

function setStickyAddToCartLoading(stickyAddToCart, isLoading) {
  const button = getStickyAddToCartButton(stickyAddToCart);

  if (!button) {
    return;
  }

  if (isLoading) {
    button.setAttribute('aria-busy', 'true');
  } else {
    button.removeAttribute('aria-busy');
  }
}

function findStickyAddToCart(formId) {
  if (!formId) {
    return null;
  }

  return document.querySelector(`product-sticky-add-to-cart[main-product-form="${CSS.escape(formId)}"]`);
}

function bindStickyAddToCartLoadingState(root = document) {
  root.querySelectorAll(`product-sticky-add-to-cart[main-product-form]:not([${STICKY_ATC_LOADING_STATE_ATTR}])`).forEach(stickyAddToCart => {
    const formId = stickyAddToCart.getAttribute('main-product-form');
    const form = formId ? document.forms[formId] : null;

    if (!form) {
      return;
    }

    stickyAddToCart.setAttribute(STICKY_ATC_LOADING_STATE_ATTR, '');

    form.addEventListener('product:rerender', () => {
      setStickyAddToCartLoading(stickyAddToCart, false);
    });

    form.addEventListener('cart:error', () => {
      setStickyAddToCartLoading(stickyAddToCart, false);
    });
  });
}

function syncStickyAddToCartMobileVisibility() {
  const shouldShow = STICKY_ATC_MOBILE_QUERY.matches && window.scrollY >= window.innerHeight * STICKY_ATC_MOBILE_REVEAL_RATIO;

  document.querySelectorAll('product-sticky-add-to-cart').forEach(stickyAddToCart => {
    stickyAddToCart.classList.toggle(STICKY_ATC_MOBILE_VISIBLE_CLASS, shouldShow);
  });
}

function requestStickyAddToCartMobileVisibilitySync() {
  if (stickyAddToCartMobileTicking) {
    return;
  }

  stickyAddToCartMobileTicking = true;

  window.requestAnimationFrame(() => {
    syncStickyAddToCartMobileVisibility();
    stickyAddToCartMobileTicking = false;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    bindStickyAddToCartLoadingState();
    syncStickyAddToCartMobileVisibility();
  }, { once: true });
} else {
  bindStickyAddToCartLoadingState();
  syncStickyAddToCartMobileVisibility();
}

document.addEventListener('shopify:section:load', () => {
  bindStickyAddToCartLoadingState();
  syncStickyAddToCartMobileVisibility();
});

window.addEventListener('scroll', requestStickyAddToCartMobileVisibilitySync, { passive: true });
window.addEventListener('resize', requestStickyAddToCartMobileVisibilitySync);

if (typeof STICKY_ATC_MOBILE_QUERY.addEventListener === 'function') {
  STICKY_ATC_MOBILE_QUERY.addEventListener('change', syncStickyAddToCartMobileVisibility);
} else {
  STICKY_ATC_MOBILE_QUERY.addListener(syncStickyAddToCartMobileVisibility);
}

document.addEventListener('change', event => {
  const optionInput = event.target.closest('input[data-option-position][form]');

  if (!optionInput) {
    return;
  }

  setStickyAddToCartLoading(findStickyAddToCart(optionInput.getAttribute('form')), true);
});

document.addEventListener('click', event => {
  const optionButton = event.target.closest('.rftp-sticky-atc__option-value');

  if (!optionButton) {
    return;
  }

  const stickyAddToCart = optionButton.closest('product-sticky-add-to-cart');
  const formId = stickyAddToCart?.getAttribute('main-product-form');
  const optionPosition = optionButton.getAttribute('data-option-position');
  const optionValue = optionButton.getAttribute('data-option-value');

  if (!formId || !optionPosition || !optionValue) {
    return;
  }

  const matchingInput = document.querySelector(
    `input[data-option-position="${CSS.escape(optionPosition)}"][form="${CSS.escape(formId)}"][value="${CSS.escape(optionValue)}"]`
  );

  optionButton.closest('details')?.removeAttribute('open');

  if (!matchingInput || matchingInput.checked) {
    return;
  }

  // Sold-out options must remain selectable so customers can use actions such as wishlist.
  matchingInput.disabled = false;
  setStickyAddToCartLoading(stickyAddToCart, true);
  matchingInput.checked = true;
  matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('click', event => {
  document.querySelectorAll('.rftp-sticky-atc__field[open]').forEach(dropdown => {
    if (!dropdown.contains(event.target)) {
      dropdown.removeAttribute('open');
    }
  });
});

// SHOP THE LOOK QUICK ADD
class RftpComplementaryProductForm extends HTMLElement {
  connectedCallback() {
    this.productData = JSON.parse(this.querySelector('[data-product-json]')?.textContent || '{"variants":[]}');
    this.form = this.querySelector('form[action*="/cart/add"]');
    this.variantIdInput = this.form?.querySelector('input[name="id"]');
    this.priceContainer = this.closest('[data-rftp-product-details], .rftp-shopthelook__productDetails')?.querySelector('[data-price]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.selects = Array.from(this.querySelectorAll('select[data-option-position]'));

    this.onSelectChange = this.onSelectChange.bind(this);
    this.selects.forEach(select => select.addEventListener('change', this.onSelectChange));

    this.syncState();
  }

  disconnectedCallback() {
    this.selects?.forEach(select => select.removeEventListener('change', this.onSelectChange));
  }

  get selectedValues() {
    return this.selects.map(select => select.value);
  }

  findMatchingVariant(optionValues) {
    return this.productData.variants.find(variant =>
      variant.options.every((optionValue, index) => optionValue === optionValues[index])
    );
  }

  hasMatchingVariantForValue(optionIndex, value, selectedValues) {
    return this.productData.variants.some(variant =>
      variant.options[optionIndex] === value
      && variant.options.every((optionValue, index) => index === optionIndex || optionValue === selectedValues[index])
    );
  }

  updateOptionAvailability() {
    // We resolve invalid combinations by progressively moving each select to the first valid value.
    this.selects.forEach((select, optionIndex) => {
      const selectedValues = this.selectedValues;

      Array.from(select.options).forEach(option => {
        option.disabled = !this.hasMatchingVariantForValue(optionIndex, option.value, selectedValues);
      });

      if (select.selectedOptions[0]?.disabled) {
        const firstEnabledOption = Array.from(select.options).find(option => !option.disabled);

        if (firstEnabledOption) {
          select.value = firstEnabledOption.value;
        }
      }
    });
  }

  updateSubmitButton(variant) {
    if (!this.submitButton) {
      return;
    }

    const buttonLabel = !variant
      ? this.dataset.unavailableLabel
      : variant.available
        ? this.dataset.availableLabel
        : this.dataset.soldOutLabel;

    this.submitButton.disabled = !variant || !variant.available;

    const buttonContent = this.submitButton.querySelector('button-content');

    if (!buttonContent) {
      return;
    }

    buttonContent.textContent = buttonLabel;

    if (buttonContent.hasAttribute('rotated-text')) {
      buttonContent.setAttribute('rotated-text', buttonLabel);
    }

    if (buttonContent.hasAttribute('up-text')) {
      buttonContent.setAttribute('up-text', buttonLabel);
    }
  }

  updatePrice(variant) {
    if (!this.priceContainer || !variant?.priceHtml) {
      return;
    }

    this.priceContainer.innerHTML = variant.priceHtml;
  }

  syncState() {
    this.updateOptionAvailability();
    this.updateOptionAvailability();

    const matchingVariant = this.findMatchingVariant(this.selectedValues);

    if (this.variantIdInput) {
      this.variantIdInput.value = matchingVariant?.id || '';
    }

    this.updatePrice(matchingVariant);
    this.updateSubmitButton(matchingVariant);
  }

  onSelectChange() {
    this.syncState();
  }
}

if (!window.customElements.get('rftp-complementary-product-form')) {
  window.customElements.define('rftp-complementary-product-form', RftpComplementaryProductForm);
}

// UGC COLLECTION BLOCK
class RftpUgc extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rftp-ugc-track]');
    this.slides = Array.from(this.querySelectorAll('[data-rftp-ugc-slide]'));
    this.productPanelsContainer = this.querySelector('.rftp-ugc__product-panels');
    this.productPanels = Array.from(this.querySelectorAll('[data-rftp-ugc-products]'));
    this.links = Array.from(this.querySelectorAll('[data-rftp-ugc-link]'));
    this.prevButton = this.querySelector('[data-rftp-ugc-prev]');
    this.nextButton = this.querySelector('[data-rftp-ugc-next]');
    this.activeIndex = 0;

    if (!this.track || this.slides.length === 0) {
      return;
    }

    this.onPrevClick = () => this.goToSlide(this.activeIndex - 1);
    this.onNextClick = () => this.goToSlide(this.activeIndex + 1);
    this.onTrackScroll = () => this.requestActiveSlideSync();
    this.onScrollResumeVideos = () => this.requestAutoplayVideoResume();
    this.onResize = () => {
      this.syncProductPanelsHeight();
      this.scrollToActiveSlide(false);
    };

    this.prevButton?.addEventListener('click', this.onPrevClick);
    this.nextButton?.addEventListener('click', this.onNextClick);
    this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
    this.track.addEventListener('scroll', this.onScrollResumeVideos, { passive: true });
    window.addEventListener('scroll', this.onScrollResumeVideos, { passive: true });
    window.addEventListener('resize', this.onResize);

    this.setActiveSlide(0);
    this.syncProductPanelsHeight();
    this.requestAutoplayVideoResume();
    this.updateControlState();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.onPrevClick);
    this.nextButton?.removeEventListener('click', this.onNextClick);
    this.track?.removeEventListener('scroll', this.onTrackScroll);
    this.track?.removeEventListener('scroll', this.onScrollResumeVideos);
    window.removeEventListener('scroll', this.onScrollResumeVideos);
    window.removeEventListener('resize', this.onResize);

    if (this.scrollFrame) {
      window.cancelAnimationFrame(this.scrollFrame);
    }

    if (this.videoResumeFrame) {
      window.cancelAnimationFrame(this.videoResumeFrame);
    }

    if (this.scrollSyncTimeout) {
      window.clearTimeout(this.scrollSyncTimeout);
    }
  }

  requestActiveSlideSync() {
    if (this.isProgrammaticScroll) {
      return;
    }

    if (this.scrollFrame) {
      window.cancelAnimationFrame(this.scrollFrame);
    }

    this.scrollFrame = window.requestAnimationFrame(() => {
      this.scrollFrame = null;
      this.setActiveSlide(this.getNearestSlideIndex());
    });
  }

  getNearestSlideIndex() {
    const trackLeft = this.track.getBoundingClientRect().left;

    return this.slides.reduce((nearestIndex, slide, index) => {
      const nearestDistance = Math.abs(this.slides[nearestIndex].getBoundingClientRect().left - trackLeft);
      const slideDistance = Math.abs(slide.getBoundingClientRect().left - trackLeft);

      return slideDistance < nearestDistance ? index : nearestIndex;
    }, this.activeIndex);
  }

  requestAutoplayVideoResume() {
    if (this.videoResumeFrame) {
      window.cancelAnimationFrame(this.videoResumeFrame);
    }

    this.videoResumeFrame = window.requestAnimationFrame(() => {
      this.videoResumeFrame = null;
      this.resumeAutoplayVideos();
    });
  }

  resumeAutoplayVideos() {
    this.querySelectorAll('video-media[autoplay]').forEach(media => {
      media.play?.();

      const video = media.querySelector('video');

      if (video?.paused && video.muted) {
        video.play().catch(() => {});
      }
    });
  }

  syncProductPanelsHeight() {
    if (!this.productPanelsContainer || this.productPanels.length === 0) {
      return;
    }

    const containerStyle = getComputedStyle(this.productPanelsContainer);
    const contentWidth = this.productPanelsContainer.clientWidth
      - parseFloat(containerStyle.paddingLeft)
      - parseFloat(containerStyle.paddingRight);

    const maxHeight = this.productPanels.reduce((height, panel) => {
      const wasHidden = panel.hidden;
      const previousStyles = {
        left: panel.style.left,
        pointerEvents: panel.style.pointerEvents,
        position: panel.style.position,
        top: panel.style.top,
        visibility: panel.style.visibility,
        width: panel.style.width
      };

      if (wasHidden) {
        panel.hidden = false;
        panel.style.left = `${parseFloat(containerStyle.paddingLeft)}px`;
        panel.style.pointerEvents = 'none';
        panel.style.position = 'absolute';
        panel.style.top = '0';
        panel.style.visibility = 'hidden';
        panel.style.width = `${contentWidth}px`;
      }

      const measuredHeight = panel.offsetHeight;

      if (wasHidden) {
        panel.hidden = true;
        panel.style.left = previousStyles.left;
        panel.style.pointerEvents = previousStyles.pointerEvents;
        panel.style.position = previousStyles.position;
        panel.style.top = previousStyles.top;
        panel.style.visibility = previousStyles.visibility;
        panel.style.width = previousStyles.width;
      }

      return Math.max(height, measuredHeight);
    }, 0);

    if (maxHeight > 0) {
      this.productPanelsContainer.style.minHeight = `${maxHeight}px`;
    }
  }

  goToSlide(index) {
    const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));

    if (nextIndex === this.activeIndex) {
      return;
    }

    this.setActiveSlide(nextIndex);
    this.scrollToActiveSlide();
  }

  scrollToActiveSlide(animate = true) {
    const slide = this.slides[this.activeIndex];

    if (!slide) {
      return;
    }

    const trackLeft = this.track.getBoundingClientRect().left;
    const slideLeft = slide.getBoundingClientRect().left;

    if (animate) {
      this.isProgrammaticScroll = true;

      if (this.scrollSyncTimeout) {
        window.clearTimeout(this.scrollSyncTimeout);
      }

      this.scrollSyncTimeout = window.setTimeout(() => {
        this.isProgrammaticScroll = false;
        this.setActiveSlide(this.getNearestSlideIndex());
      }, 450);
    }

    this.track.scrollTo({
      left: this.track.scrollLeft + slideLeft - trackLeft,
      behavior: animate ? 'smooth' : 'auto'
    });
  }

  setActiveSlide(index) {
    if (!this.slides[index]) {
      return;
    }

    this.activeIndex = index;

    const activeSlide = this.slides[this.activeIndex];
    const activeUgcIndex = activeSlide?.getAttribute('data-ugc-index');

    this.slides.forEach((slide, slideIndex) => {
      if (slideIndex === this.activeIndex) {
        slide.setAttribute('aria-current', 'true');
      } else {
        slide.removeAttribute('aria-current');
      }
    });

    this.productPanels.forEach(panel => {
      panel.hidden = panel.getAttribute('data-ugc-index') !== activeUgcIndex;
    });

    this.links.forEach(link => {
      link.hidden = link.getAttribute('data-ugc-index') !== activeUgcIndex;
    });

    this.updateControlState();
  }

  updateControlState() {
    const hasMultipleSlides = this.slides.length > 1;

    this.prevButton?.toggleAttribute('disabled', !hasMultipleSlides || this.activeIndex === 0);
    this.nextButton?.toggleAttribute('disabled', !hasMultipleSlides || this.activeIndex === this.slides.length - 1);
  }
}

if (!window.customElements.get('rftp-ugc')) {
  window.customElements.define('rftp-ugc', RftpUgc);
}

// CYBER BANNER GRAIN
;(() => {
  const FRAME_INTERVAL = 50;
  const MAX_PIXELS = 256;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCyberBannerGrain(root = document) {
    root.querySelectorAll('.rftp-cyberbanner:not([data-grain-ready])').forEach(banner => {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d', { alpha: true });

      if (!context) {
        return;
      }

      canvas.className = 'rftp-cyberbanner__grain';
      canvas.setAttribute('aria-hidden', 'true');
      banner.setAttribute('data-grain-ready', '');
      banner.appendChild(canvas);

      let interval = null;
      let isVisible = false;

      function draw() {
        const width = canvas.clientWidth;
        const height = canvas.clientHeight;

        if (canvas.width !== width || canvas.height !== height) {
          canvas.width = width;
          canvas.height = height;
        }

        context.clearRect(0, 0, width, height);
        context.fillStyle = `rgb(${getComputedStyle(banner).getPropertyValue('--background').trim()})`;

        const pixelCount = Math.min(MAX_PIXELS, Math.max(8, Math.round(width * height / 5000)));

        for (let index = 0; index < pixelCount; index += 1) {
          context.globalAlpha = 0.15 + Math.random() * 0.35;
          const sizeRoll = Math.random();
          const size = sizeRoll < 0.25 ? 2 : sizeRoll < 0.9 ? 4 : 6;
          context.fillRect(Math.random() * width, Math.random() * height, size, size);
        }
      }

      function syncAnimation() {
        const shouldAnimate = isVisible && !document.hidden && !reducedMotion.matches;

        if (shouldAnimate && !interval) {
          draw();
          interval = window.setInterval(draw, FRAME_INTERVAL);
        } else if (!shouldAnimate && interval) {
          window.clearInterval(interval);
          interval = null;
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
      }

      const visibilityObserver = new IntersectionObserver(entries => {
        isVisible = entries[0].isIntersecting;
        syncAnimation();
      });

      visibilityObserver.observe(banner);
      document.addEventListener('visibilitychange', syncAnimation);
      reducedMotion.addEventListener?.('change', syncAnimation);
    });
  }

  initCyberBannerGrain();
  document.addEventListener('shopify:section:load', event => initCyberBannerGrain(event.target));
})();

// HEADER RESIZER
; (() => {
  const SCROLL_TO_SQUISH_PX = 100
  let scrollReference = window.scrollY;
  let lastScrollPosition = window.scrollY;
  let lastChange = 0;

  const handleAnimFrame = () => {
    window.requestAnimationFrame(handleAnimFrame);
    if (lastScrollPosition === window.scrollY) {
      return;
    }
    let thisChange = (window.scrollY - lastScrollPosition) > 0 ? 1 : -1;
    if (thisChange !== lastChange) {
      lastChange = thisChange;
      const currentSquish = parseFloat(document.body.style.getPropertyValue('--rftp-header-logo-squish') || 0);
      scrollReference = window.scrollY - (currentSquish / 100 * SCROLL_TO_SQUISH_PX);
    }
    lastScrollPosition = window.scrollY;
    document.body.style.setProperty('--rftp-header-logo-squish', Math.min(100, Math.max(0, ((lastScrollPosition - scrollReference) / SCROLL_TO_SQUISH_PX) * 100)));
  }
  window.requestAnimationFrame(handleAnimFrame);
})();

// FILTERPRODUCTS
;(() => {
  const WIDE_BREAKPOINT = 1000;
  const MAX_WIDE_PRODUCTS = 6;

  function getActiveTag(container) {
    const activeButton = container.querySelector('.rt-filterProducts__tagSelectorEntry.-active');
    return activeButton ? activeButton.getAttribute('data-rt-tag') : null;
  }

  function applyFilter(container) {
    const tag = getActiveTag(container);
    const isWide = window.innerWidth >= WIDE_BREAKPOINT;
    const lists = container.querySelectorAll('.rt-filterProducts__list');

    lists.forEach(list => {
      let visibleCount = 0;
      const productCards = list.querySelectorAll('product-card');

      productCards.forEach(card => {
        const cardTags = card.getAttribute('data-rt-tags')?.split(',') || [];
        const matchesTag = !tag || cardTags.includes(tag);

        if (matchesTag && (!isWide || visibleCount < MAX_WIDE_PRODUCTS)) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });
    });
  }

  function handleTagButtonClick(event) {
    const button = event.currentTarget;
    const isActive = button.classList.contains('-active');

    if (isActive) return;

    const siblingButtons = button.parentElement.querySelectorAll('.rt-filterProducts__tagSelectorEntry');
    siblingButtons.forEach(sibling => sibling.classList.remove('-active'));
    button.classList.add('-active');

    applyFilter(button.closest('.rt-filterProducts'));
  }

  document.querySelectorAll('.rt-filterProducts__tagSelectorEntry').forEach(button => {
    button.addEventListener('click', handleTagButtonClick);
  });

  const containers = document.querySelectorAll('.rt-filterProducts');

  // Run on load
  containers.forEach(applyFilter);

  // Detect viewport changes
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      containers.forEach(applyFilter);
    }, 100);
  });
})();

/** Klaviyo Form Handlers */
;(() => {
  document.querySelectorAll('a[href^="#klaviyo-"]').forEach(link => {
    link.addEventListener('click', event => {
      event.preventDefault();
      const klaviyoId = link.getAttribute('href').replace('#klaviyo-' , '');
      window._klOnsite.push(['openForm', klaviyoId]);
    });
  });
})();

/** Route Fix */
;(() => {
  document.querySelector('cart-drawer').addEventListener('dialog:after-show', () => {
    // Dirty Hack to force Route to re-generate its buttons
    let checkoutButton = document.querySelector('#cart-drawer .shopify-cart-form button[type="submit"]')
    let checkoutButtonParent = checkoutButton.parentElement
    checkoutButtonParent.removeChild(checkoutButton)
    window.requestAnimationFrame(() => checkoutButtonParent.appendChild(checkoutButton))
  });
})();
